module.exports = __webpack_public_path__ + "static/media/llave.4c98cc6a.png";